import React from 'react';

function ScaleInput({ question, value, onChange }) {
  const min = question.validation?.min ?? 1;
  const max = question.validation?.max ?? 10;
  const marks = [];
  for (let i = min; i <= max; i++) {
    marks.push(i);
  }
  const current = value !== undefined && value !== null && value !== '' ? Number(value) : null;

  return (
    <div className="mt-2">
      <div className="flex justify-between gap-1">
        {marks.map((mark) => (
          <button
            key={mark}
            type="button"
            onClick={() => onChange(mark)}
            className={`flex-1 py-2 rounded-md border text-sm font-medium transition-colors
              ${current === mark
                ? 'bg-primary-700 text-white border-primary-700'
                : 'bg-white text-neutral-700 border-neutral-300 hover:border-primary-500 hover:text-primary-700'}
            `}
          >
            {mark}
          </button>
        ))}
      </div>
      <div className="flex justify-between mt-1 text-xs text-neutral-400">
        <span>Low</span>
        <span>High</span>
      </div>
    </div>
  );
}

function QuestionRenderer({ question, value, onChange, error }) {
  const base =
    'mt-1 block w-full rounded-md border border-neutral-300 px-3 py-2 text-sm shadow-sm focus:border-primary-500 focus:ring-1 focus:ring-primary-500 outline-none';

  const handleChange = (e) => onChange(e.target.value);

  const renderInput = () => {
    switch (question.type) {
      case 'text':
        return (
          <input
            type="text"
            value={value ?? ''}
            onChange={handleChange}
            maxLength={question.validation?.maxLength ?? 500}
            className={base}
          />
        );

      case 'textarea':
        return (
          <textarea
            rows={4}
            value={value ?? ''}
            onChange={handleChange}
            maxLength={question.validation?.maxLength ?? 2000}
            className={`${base} resize-y`}
          />
        );

      case 'radio':
        return (
          <div className="mt-2 space-y-2">
            {(question.options || []).map((option) => (
              <label key={option.value} className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name={question.id}
                  value={option.value}
                  checked={value === option.value}
                  onChange={() => onChange(option.value)}
                  className="text-primary-700 focus:ring-primary-500"
                />
                <span className="text-sm text-neutral-700">{option.label}</span>
              </label>
            ))}
          </div>
        );

      case 'checkbox':
        return (
          <div className="mt-2 space-y-2">
            {(question.options || []).map((option) => {
              const checked = Array.isArray(value) && value.includes(option.value);
              const handleCheck = () => {
                const current = Array.isArray(value) ? [...value] : [];
                if (checked) {
                  onChange(current.filter((v) => v !== option.value));
                } else {
                  onChange([...current, option.value]);
                }
              };
              return (
                <label key={option.value} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    value={option.value}
                    checked={checked}
                    onChange={handleCheck}
                    className="text-primary-700 focus:ring-primary-500 rounded"
                  />
                  <span className="text-sm text-neutral-700">{option.label}</span>
                </label>
              );
            })}
          </div>
        );

      case 'scale':
        return <ScaleInput question={question} value={value} onChange={onChange} />;

      case 'date':
        return (
          <input
            type="date"
            value={value ?? ''}
            onChange={handleChange}
            className={base}
          />
        );

      default:
        return (
          <input
            type="text"
            value={value ?? ''}
            onChange={handleChange}
            className={base}
          />
        );
    }
  };

  return (
    <div className="mb-6">
      <label className="block text-sm font-medium text-neutral-800">
        {question.prompt}
        {question.required && (
          <span className="ml-1 text-red-500" aria-hidden="true">*</span>
        )}
      </label>
      {renderInput()}
      {error && (
        <p className="mt-1 text-xs text-red-600">{error}</p>
      )}
    </div>
  );
}

export default QuestionRenderer;
